import React from 'react';

/**
 * Every heading on this site ("About Us", "Our Services", "Partners", the
 * hero title, etc.) uses the same markup pattern in the source HTML: each
 * word is wrapped in a clipped `.word` div, and each letter inside is its
 * own `.char` div, so GSAP can animate the letters in with a per-character
 * stagger ("scaleY 0 -> 1") as the heading scrolls into view.
 *
 * `text` can be a single string ("Our Services") or an array of word
 * strings if you need to control the reveal delay boundary manually
 * (see the "Who We Are" heading, which splits oddly in the source).
 */
export function AnimatedHeading({ text, as: Tag = 'h2', className = '' }) {
  const words = Array.isArray(text) ? text : text.split(' ');
  return (
    <Tag className={`animated-text ${className}`.trim()}>
      {words.map((word, wordIndex) => (
        <div className="word" key={wordIndex}>
          {word.split('').map((letter, letterIndex) => (
            <div className="char" key={letterIndex}>
              {letter}
            </div>
          ))}
        </div>
      ))}
    </Tag>
  );
}

/**
 * The nav-link / button "wave swap" effect: two stacked copies of the same
 * label (`.text-hover__elem-1` on top, `.text-hover__elem-2` absolutely
 * positioned underneath). On hover, `useSiteBehavior`'s GSAP timeline
 * slides elem-1's letters up and out while elem-2's letters slide up into
 * view — see the "TEXT-HOVER" block in useSiteBehavior.js.
 */
function HoverWords({ words }) {
  return words.map((word, wordIndex) => (
    <div className="word" key={wordIndex}>
      {word.split('').map((letter, letterIndex) => (
        <div className="char" key={letterIndex}>
          {letter}
        </div>
      ))}
    </div>
  ));
}

export function HoverText({ words, darkSecond = false }) {
  const wordList = Array.isArray(words) ? words : words.split(' ');
  return (
    <span className="text-hover__inner">
      <span className="text-hover__elem text-hover__elem-1">
        <HoverWords words={wordList} />
      </span>
      <span
        className={`text-hover__elem text-hover__elem-2${darkSecond ? ' _c-dark' : ''}`}
      >
        <HoverWords words={wordList} />
      </span>
    </span>
  );
}
